import { Link, useLocation } from 'react-router-dom';
import { ROUTES } from '../constants/routes';

export function Header() {
  const location = useLocation();

  const scrollToAbout = (e) => {
    e.preventDefault();
    if (location.pathname !== ROUTES.HOME) {
      window.location.href = ROUTES.ABOUT;
      return;
    }
    const scrollEl = document.querySelector('.main-scroll');
    const el = document.getElementById('about');
    if (scrollEl && el) {
      const y = el.getBoundingClientRect().top + scrollEl.scrollTop - 20;
      scrollEl.scrollTo({ top: y, behavior: 'smooth' });
    }
  };

  return (
    <header className="navbar" role="banner">
      <nav className="nav-container" role="navigation" aria-label="Main navigation">
        <Link to={ROUTES.HOME} className="logo" aria-label="9MM Defense Home">
          <img src="/9mm.png" alt="9MM Defense Logo" className="small-logo" width="103" height="auto" />
        </Link>
        <ul className="nav-links" role="menubar">
          <li role="none">
            <Link
              to={ROUTES.HOME}
              role="menuitem"
              aria-current={location.pathname === ROUTES.HOME ? 'page' : undefined}
            >
              HOME
            </Link>
          </li>
          <li role="none">
            <Link to={ROUTES.ABOUT} role="menuitem" onClick={scrollToAbout}>
              ABOUT
            </Link>
          </li>
          <li role="none">
            <a href={ROUTES.PRODUCTS} role="menuitem">
              PRODUCTS
            </a>
          </li>
          <li role="none">
            <Link to={ROUTES.CONTACT} role="menuitem">
              CONTACT
            </Link>
          </li>
        </ul>
      </nav>
    </header>
  );
}
